import parse from "html-react-parser";

import { useLanguage } from "~/context/LanguageContext";

import i18n from "./i18n";

export default function ArticleIntroduction() {
  const { lang } = useLanguage();
  const t = i18n[lang];

  return (
    <>
      <div className="cs-height_100 cs-height_lg_80"></div>
      <div className="container">
        <div className="cs-section_heading cs-style1 text-center">
          <h3 className="cs-section_subtitle">{t.title}</h3>
          <h2
            className="cs-section_title wow fadeInUp"
            data-wow-duration="0.8s"
            data-wow-delay="0.2s"
          >
            {t.subtitle}
          </h2>
        </div>
        <div className="cs-height_90 cs-height_lg_45"></div>
        <img
          src="/img/courses/case_study_img_1.webp"
          alt="Software Design and Architecture"
          className="w-100 cs-radius_15"
        />
        <div className="cs-height_140 cs-height_lg_80"></div>
        <h2
          className="cs-font_38 text-center cs-m0 wow fadeInUp"
          data-wow-duration="0.8s"
          data-wow-delay="0.2s"
        >
          {t.overviewTitle}
        </h2>
        <div className="cs-height_60 cs-height_lg_45"></div>
        {parse(t.overview)}
        <div className="cs-height_65 cs-height_lg_45"></div>
        <div className="cs-height_125 cs-height_lg_55"></div>
      </div>
    </>
  );
}
